import { z } from "zod";
const allScheduleWeekdays = [
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
  "sunday"
];
const scheduleWeekdaySchema = z.enum(allScheduleWeekdays);
const allScheduleFrequencies = [
  "hourly",
  "daily",
  "weekly",
  "monthly"
];
const monthlyScheduleSchema = z.discriminatedUnion("kind", [
  z.object({ kind: z.literal("first_day_of_month") }),
  z.object({
    kind: z.literal("first_weekday_of_month"),
    weekday: scheduleWeekdaySchema
  }),
  z.object({ kind: z.literal("last_day_of_month") })
]);
const scheduleTimeOfDaySchema = z.string().regex(/^([01]\d|2[0-3]):[0-5]\d$/);
const recurringScheduleSchema = z.discriminatedUnion("frequency", [
  z.object({ frequency: z.literal("hourly") }),
  z.object({
    frequency: z.literal("daily"),
    time_of_day: scheduleTimeOfDaySchema
  }),
  z.object({
    frequency: z.literal("weekly"),
    weekdays: z.array(scheduleWeekdaySchema).min(1),
    time_of_day: scheduleTimeOfDaySchema
  }),
  z.object({
    frequency: z.literal("monthly"),
    schedule: monthlyScheduleSchema,
    time_of_day: scheduleTimeOfDaySchema
  })
]);
export {
  allScheduleFrequencies,
  allScheduleWeekdays,
  monthlyScheduleSchema,
  recurringScheduleSchema,
  scheduleWeekdaySchema
};
//# sourceMappingURL=recurringSchedule.js.map
